import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { FarmService } from 'src/app/services/farm-service.service';
import { ProcessService } from 'src/app/services/process.service';
import { empty } from 'rxjs';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import Swal from 'sweetalert2';
import { combineAll } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'smart-config-emoticon',
  templateUrl: './config-emoticon.component.html',
  styleUrls: ['./config-emoticon.component.css','../platform-color/platform-color.css']
})
export class ConfigEmoticonComponent implements OnInit {

  userrole = sessionStorage.getItem("role");
  dtEmo: any = [];
  thingsByid: any = [];
  farmId: any;
  plotId: any;
  sensorAll: any = [];
  showSensor: any;
  formEmoticon: FormGroup;
  formEditEmoticon: FormGroup;
  stepbtn: any = 0;
  sensorAllOther: any = [];
  mergeArr: any = [];
  dataMain: any = [];
  ssname: any;
  edt = false;
  schkBtw = false;
  arr: any;
  chkConfigEditEmo = false;
  chkConfigEmo = true;
  alertErrorEmo = false;
  alertErrorEdtEmo = false;
  addCondition1 = false;
  addCondition2 = false;
  addCondition3 = false;
  @Input() icon_path: string;
  constructor(
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private farmService: FarmService,
    private processService: ProcessService,
    private router: Router,
    private farm: FormBuilder,
  ) {
    this.formEmoticon = this.farm.group({
      data: this.farm.array([]),
    });

    this.formEditEmoticon = this.farm.group({
      data: this.farm.array([]),
    });
  }
  ValidateValue(id, value, emoId) {
    if (id == 'edt_txt_val_main' + emoId && (value == '' || value == null)) {
      $('#errEmoValue' + emoId).removeClass('dis-none');
    } else if (id == 'edt_txt_val' + emoId || id == 'edt_txt_val_to' + emoId) {
      if ($('#edt_txt_val' + emoId).val() == '' || $('#edt_txt_val' + emoId).val() == null) {
        $('#errEmoValue' + emoId).removeClass('dis-none');
      } else if ($('#edt_txt_val_to' + emoId).val() == '' || $('#edt_txt_val_to' + emoId).val() == null) {
        $('#errEmoValue' + emoId).removeClass('dis-none');
      } else {
        $('#errEmoValue' + emoId).addClass('dis-none');
      }
    }
    else if (id == 'edt_txt_val_main' + emoId && (value !== '' || value !== null)) {
      $('#errEmoValue' + emoId).addClass('dis-none');
    }
    else {
      $('#errEmoValue' + emoId).addClass('dis-none');
    }



  }
  ngOnInit() {



    // this.chkButtonEditEmo();
    // $('#editEmoPlant').prop("disabled", false);
    this.route.params.subscribe(routeParams => {
      window.scroll(0, 0);
      //window.scroll(0, 1000);
      this.farmId = this.route.snapshot.queryParams["farmId"];
      this.plotId = this.route.snapshot.queryParams["plotId"];


    });
    // this.getPlot();
    this.getEmo();
    this.getThingsById();

  }
  // async getPlot() {
  //   console.log("(this.plotId : ", this.plotId)
  //   await this.farmService.getPlotDetailByID(this.plotId).subscribe(async success => {
  //     console.log("smart-plot-detail getPlot emo success !: ", success)
  //     if (success.code == 200) {
  //       this.icon_path = success.data[0].icon_path ? success.data[0].icon_path : `/assets/img/emoticon/`
  //       console.log("this.icon_path", this.icon_path)
  //       // farm_name = success.data[0].farm.name;
  //       // plot_name = success.data[0].name;
  //       //this.spinner.hide();
  //     }
  //   });
  // }

  getEmo() {
    this.dtEmo = [];
    this.spinner.show();
    setTimeout(async () => {

      await this.farmService.getAllEmobyPlotAndFarm(this.farmId, this.plotId).subscribe(async success => {
        let data = success.data.sort(function (a, b) {
            if (a.emo_status < b.emo_status) { return -1; }
            if (a.emo_status > b.emo_status) { return 1; }
            return 0;
          });
        this.arr = data;
        this.arrForm(data);
        this.chkButtonEditEmo(data);

        data.forEach(element => {
      
          if (element.condition != null) {
       
            let parseArr = JSON.parse(element.condition);
    
            this.dtEmo.push({
              data: element,
              condition: parseArr
            });
          }
        });
    
        if (this.dtEmo.length > 0) this.editEmo(this.dtEmo)
        this.spinner.hide();
      });
      this.spinner.hide();
    }, 1);
  }

  arrForm(arr) {

    // const checkSensor = [];

    // this.arrSensor = [];
    this.formEmoticon = this.farm.group({
      data: this.farm.array([]),
    });
    if (arr) {
      arr.forEach(element => {
        const checkEmo = <FormArray>this.formEmoticon.get('data') as FormArray;
        if (element.condition == null) {
          checkEmo.push(this.farm.group({
            emoId: element.emo_status,
            thing_id: '',
            sensor_id: '',
            condition: '',
            target_emo: '',
            target_emo2: '',
            other_condition_with1: '',
            other_condition_with2: '',
            other_condition_with3: '',
            other_thing_id: '',
            other_sensor_id: '',
            other_condition: '',
            other_target_emo: '',
            other_target_emo2: '',
          }))
        }
      });
    }


  }

  getThingsById() {
    this.spinner.show();
    setTimeout(async () => {

      this.farmService.getThingById(this.farmId, this.plotId)
        .subscribe(async success => {

          if (success.code == 200) {
            this.thingsByid = success.data;
            // this.arrForm(this.sensorAll);
            // console.clear()
          }
        });


      this.spinner.hide();
    }, 100);
  }

  selectThing(event, id) {

    this.spinner.show();
    setTimeout(async () => {
      // if (event == "กรุณาเลือกThings") {
      //   this.sensorAll = [];
      // } else {
      //console.log("selectThings",event);

      if (id == "1") {
        await this.farmService.getSensorByThingsID(event,this.plotId).subscribe(async success => {

          this.sensorAll[1] = success.data;
        });
      } else if (id == "2") {
        await this.farmService.getSensorByThingsID(event,this.plotId).subscribe(async success => {
          this.sensorAll[2] = success.data;
        });
      } else if (id == "3") {
        await this.farmService.getSensorByThingsID(event,this.plotId).subscribe(async success => {
          this.sensorAll[3] = success.data;
        });
      }
      // console.clear();


      // }

      this.spinner.hide();
    }, 100);
  }

  selectThingOther(event, id) {

    this.spinner.show();
    setTimeout(async () => {
      // if (event == "กรุณาเลือกThings") {
      //   this.sensorAllOther = [];
      // } else {
      //console.log("selectThings",event);

      if (id == "1") {
        await this.farmService.getSensorByThingsID(event,this.plotId).subscribe(async success => {
          this.sensorAllOther[1] = success.data;
        });
      } else if (id == "2") {
        await this.farmService.getSensorByThingsID(event,this.plotId).subscribe(async success => {
          this.sensorAllOther[2] = success.data;
        });
      } else if (id == "3") {
        await this.farmService.getSensorByThingsID(event,this.plotId).subscribe(async success => {
          this.sensorAllOther[3] = success.data;
        });
      }
      // console.clear();


      // }

      this.spinner.hide();
    }, 100);
  }
  // issue#106
  async chkSubmitConfigEmo() {
    this.chkConfigEmo = true;

    let things1 = this.formEmoticon.value.data[0].thing_id
    let things2 = this.formEmoticon.value.data[1].thing_id
    let things3 = this.formEmoticon.value.data[2].thing_id
    let sensor1 = this.formEmoticon.value.data[0].sensor_id
    let sensor2 = this.formEmoticon.value.data[1].sensor_id
    let sensor3 = this.formEmoticon.value.data[2].sensor_id
    let cond1 = this.formEmoticon.value.data[0].condition
    let cond2 = this.formEmoticon.value.data[1].condition
    let cond3 = this.formEmoticon.value.data[2].condition
    let value1 = this.formEmoticon.value.data[0].target_emo
    let value2 = this.formEmoticon.value.data[1].target_emo
    let value3 = this.formEmoticon.value.data[2].target_emo
    let subValue1 = this.formEmoticon.value.data[0].target_emo
    let subValue2 = this.formEmoticon.value.data[1].target_emo
    let subValue3 = this.formEmoticon.value.data[2].target_emo
    let subValueTo1 = this.formEmoticon.value.data[0].target_emo2
    let subValueTo2 = this.formEmoticon.value.data[1].target_emo2
    let subValueTo3 = this.formEmoticon.value.data[2].target_emo2

    let AndOr1 = this.formEmoticon.value.data[0].other_condition_with1
    let AndOr2 = this.formEmoticon.value.data[1].other_condition_with2
    let AndOr3 = this.formEmoticon.value.data[2].other_condition_with3

    let things_other1 = this.formEmoticon.value.data[0].other_thing_id
    let things_other2 = this.formEmoticon.value.data[1].other_thing_id
    let things_other3 = this.formEmoticon.value.data[2].other_thing_id
    let sensor_other1 = this.formEmoticon.value.data[0].other_sensor_id
    let sensor_other2 = this.formEmoticon.value.data[1].other_sensor_id
    let sensor_other3 = this.formEmoticon.value.data[2].other_sensor_id
    let cond_other1 = this.formEmoticon.value.data[0].other_condition
    let cond_other2 = this.formEmoticon.value.data[1].other_condition
    let cond_other3 = this.formEmoticon.value.data[2].other_condition
    let value_other1 = this.formEmoticon.value.data[0].other_target_emo
    let value_other2 = this.formEmoticon.value.data[1].other_target_emo
    let value_other3 = this.formEmoticon.value.data[2].other_target_emo
    let subValue_other1 = this.formEmoticon.value.data[0].other_target_emo
    let subValue_other2 = this.formEmoticon.value.data[1].other_target_emo
    let subValue_other3 = this.formEmoticon.value.data[2].other_target_emo
    let subValueTo_other1 = this.formEmoticon.value.data[0].other_target_emo2
    let subValueTo_other2 = this.formEmoticon.value.data[1].other_target_emo2
    let subValueTo_other3 = this.formEmoticon.value.data[2].other_target_emo2


    if (things1 == 'กรุณาเลือกThings' || things1 == null || things2 == 'กรุณาเลือกThings' || things2 == null || things3 == 'กรุณาเลือกThings' || things3 == null || sensor1 == null || sensor2 == null || sensor3 == null || cond1 == null || cond2 == null || cond3 == null) {

      this.chkConfigEmo = false;
    }
    if (cond1) {
      if (cond1 == '5') {
        if (subValue1 == '' || subValueTo1 == '') {


          this.chkConfigEmo = false;
        }
      } else {
        if (value1 == '') {
 

          this.chkConfigEmo = false;
        }
      }
    } else {
      this.chkConfigEmo = false;
    }
    if (cond2) {
      if (cond2 == '5') {
        if (subValue2 == '' || subValueTo2 == '') {


          this.chkConfigEmo = false;
        }
      } else {
        if (value2 == '') {

          this.chkConfigEmo = false;
        }
      }
    } else {
      this.chkConfigEmo = false;
    }
    if (cond3) {
      if (cond3 == '5') {
        if (subValue3 == '' || subValueTo3 == '') {

          this.chkConfigEmo = false;
        }
      } else {
        if (value3 == '') {
 
          this.chkConfigEmo = false;
        }
      }
    } else {
      this.chkConfigEmo = false;
    }
    if (this.addCondition1) {
      if (AndOr1) {
        // console.log(" !!! AndOr1 !!! ", AndOr1)
        if (things_other1 == 'กรุณาเลือกThings' || things_other1 == null || sensor_other1 == null || cond_other1 == null) {
          this.chkConfigEmo = false;
        }
        if (cond_other1 == '5') {
          if (subValue_other1 == '' || subValueTo_other1 == '') {
            this.chkConfigEmo = false;
          }
        } else {
          if (value_other1 == '') {
            this.chkConfigEmo = false;
          }
        }
      }
      else {
        this.chkConfigEmo = false;
      }
    }
    if (this.addCondition2) {
      if (AndOr2) {
        // console.log(" !!! AndOr2 !!! ", AndOr2)

        if (things_other2 == 'กรุณาเลือกThings' || things_other2 == null || sensor_other2 == null || cond_other2 == null) {
          this.chkConfigEmo = false;
        }
        if (cond_other2 == '5') {
          if (subValue_other2 == '' || subValueTo_other2 == '') {
            this.chkConfigEmo = false;
          }
        } else {
          if (value_other2 == '') {
            this.chkConfigEmo = false;
          }
        }
      } else {
        this.chkConfigEmo = false;
      }
    }
    if (this.addCondition2) {
      if (AndOr3) {
        // console.log(" !!! AndOr3 !!! ", AndOr3)

        if (things_other3 == 'กรุณาเลือกThings' || things_other3 == null || sensor_other3 == null || cond_other3 == null) {
          this.chkConfigEmo = false;
        }
        if (cond_other3 == '5') {
          if (subValue_other3 == '' || subValueTo_other3 == '') {
            this.chkConfigEmo = false;
          }
        } else {
          if (value_other3 == '') {
            this.chkConfigEmo = false;
          }
        }
      } else {
        this.chkConfigEmo = false;
      }
    }


  }

  configEmo(value) {
    // console.log("configEmo.....value...>>>>", value);
    this.chkSubmitConfigEmo();
    if (this.chkConfigEmo == true) {
      this.alertErrorEmo = false;
      let operationSet = [];
      this.dataMain = [];

      operationSet["1"] = ">";
      operationSet["2"] = "<";
      operationSet["3"] = "=";
      operationSet["4"] = "<>";
      operationSet["5"] = "BETWEEN";

      value.data.forEach(element => {
        // console.log("configEmo element : ", element)
        let mrgCondition = [];

        if (element.thing_id != "") {
          let Condition = {
            thing_id: element.thing_id,
            sensor_id: element.sensor_id,
            operation: operationSet[element.condition],
            Value1: element.target_emo,
            Value2: element.target_emo2 == "" ? null : element.target_emo2,
          };

          if (element.other_thing_id != "") {
            let conditionTwo = {
              thing_id: element.other_thing_id,
              sensor_id: element.other_sensor_id,
              operation: operationSet[element.other_condition],
              Value1: element.other_target_emo,
              Value2: element.other_target_emo2 == "" ? null : element.other_target_emo2,
            };

            mrgCondition.push(Condition, conditionTwo)
          } else {
            mrgCondition.push(Condition)
          }

          // console.log("configEmo element.emo_status : ", element.emoId)
          let jsonData = JSON.stringify(mrgCondition);
          let other_condition_with = 'other_condition_with' + element.emoId
          // console.log("configEmo other_condition_with : ", other_condition_with)

          this.dataMain.push({
            emo_status: element.emoId,
            comp_code: sessionStorage.getItem("comp_code"),
            condition: jsonData,
            operation: element[other_condition_with],
            user: sessionStorage.getItem("userid")
          })
          // console.log("::data::", this.dataMain);
        }
      });

      if (this.dataMain.length > 0) {
        this.mergeArr = {
          farm_id: this.farmId,
          plot_id: this.plotId,
          data: this.dataMain
        }
      }

      // console.log("this.mergeArr===>", this.mergeArr);

      this.spinner.show();
      setTimeout(async () => {
        await this.farmService.getUpdateEmobyPlot(this.mergeArr).subscribe(async success => {
          //console.log("resUpdateEmo",res);
          if (success.code == 200) {
            $('#setEmoticon').modal('hide');
            Swal.fire({
              icon: 'success',
              title: 'ดำเนินการเสร็จสิ้น',
              showConfirmButton: false,
              timer: 1500
            })

            this.spinner.show();
            setTimeout(async () => {
              // window.location.reload();
              this.getEmo();
              this.spinner.hide();
            }, 1800);
          } else {
            $('#setEmoticon').modal('hide');
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาดในการสร้างฟาร์ม กรุณาลองใหม่อีกครั้ง',
              showConfirmButton: false,
              timer: 1500
            })
          }
        });

        this.spinner.hide();
      }, 100);
    }
    else {
      // console.log("@#!@#!@#!@#!")
      this.alertErrorEmo = true;
    }
  }


  addEmocondition(id, screen_type) {
    // console.log("....addEmocondition......", id, screen_type);
    if (id == '1') this.addCondition1 = true
    if (id == '2') this.addCondition2 = true
    if (id == '3') this.addCondition3 = true
    // console.log("....addEmocondition......", this.addCondition1, this.addCondition2, this.addCondition3);

    if (screen_type == 'pc') {
      $('#pnCondition-pc-' + id).removeClass('dis-none');
      $('#pnCondition-edit-pc-' + id).removeClass('dis-none');
      $('#edt_btnAddCondition-pc-' + id).addClass('disabled');
      $('#btnAddCondition-pc-' + id).addClass('disabled');
    } else {
      $('#pnCondition-mb-' + id).removeClass('dis-none');
      $('#pnCondition-edit-mb-' + id).removeClass('dis-none');
      $('#edt_btnAddCondition-mb-' + id).addClass('disabled');
      $('#btnAddCondition-mb-' + id).addClass('disabled');
    }
  }

  removeEmocondition(id, type, screen_type) {
    // console.log("....removeEmocondition......", id);
    if (id == '1') this.addCondition1 = false
    if (id == '2') this.addCondition2 = false
    if (id == '3') this.addCondition3 = false
    // console.log("....removeEmocondition......", this.addCondition1, this.addCondition2, this.addCondition3);

    if (screen_type == 'pc') {
      $('#pnCondition-pc-' + id).addClass('dis-none');
      $('#pnCondition-edit-pc-' + id).addClass('dis-none');
      $('#edt_btnAddCondition-pc-' + id).removeClass('disabled');
      $('#btnAddCondition-pc-' + id).removeClass('disabled');
    } else {
      $('#pnCondition-mb-' + id).addClass('dis-none');
      $('#pnCondition-edit-mb-' + id).addClass('dis-none');
      $('#edt_btnAddCondition-mb-' + id).removeClass('disabled');
      $('#btnAddCondition-mb-' + id).removeClass('disabled');
    }


    if (type == 'configEditEmo') {
      $('#edt_other_thing_id' + id).val('');
      $('#edt_other_thing_id-mb-' + id).val('');
      $('#edt_other_sensor_id' + id).val('');
      $('#edt_other_sensor_id-mb-' + id).val('');
      $('#edt_other_condition' + id).val('');
      $('#edt_other_condition-mb-' + id).val('');
      $('#edt_other_target_emo' + id).val('');
      $('#edt_other_target_emo-mb-' + id).val('');
      $('#edt_txt_val_str' + id).val('');
      $('#edt_txt_val_str-mb-' + id).val('');
      $('#edt_txt_val_oth_to' + id).val('');
      $('#edt_txt_val_oth_to-mb-' + id).val('');
      $('#other_condition_and_with' + id).prop("checked", false);
      $('#other_condition_or_with' + id).prop("checked", false);
      $('#other_condition_mb_and_with' + id).prop("checked", false);
      $('#other_condition_mb_or_with' + id).prop("checked", false);

      for (let i = 0; i < this.formEditEmoticon.value.data.length; i++) {
        if (this.formEditEmoticon.value.data[i].emoId == id) {
          // this.formEditEmoticon.value.data[i].other_condition_with.clear();
          // this.formEditEmoticon.value.data[i].other_thing_id.clear();
          // this.formEditEmoticon.value.data[i].other_sensor_id.clear();
          // this.formEditEmoticon.value.data[i].other_condition.clear();
          // this.formEditEmoticon.value.data[i].other_target_emo.clear();
          // this.formEditEmoticon.value.data[i].other_target_emo2.clear();
          this.formEditEmoticon.value.data[i].other_thing_id = "";
          this.formEditEmoticon.value.data[i].other_sensor_id = "";
          this.formEditEmoticon.value.data[i].other_condition = "";
          this.formEditEmoticon.value.data[i].other_target_emo = "";
          this.formEditEmoticon.value.data[i].other_target_emo2 = "";
          if (id == '1') {
            this.formEditEmoticon.value.data[i].other_condition_with1 = "";
            this.sensorAllOther[id] = [];
          }
          if (id == '2') {
            this.formEditEmoticon.value.data[i].other_condition_with2 = "";
            this.sensorAllOther[id] = [];
          }
          if (id == '3') {
            this.formEditEmoticon.value.data[i].other_condition_with3 = "";
            this.sensorAllOther[id] = [];
          }

        }
      }

    } else {
      // console.log("form ADD");

      $('#other_condition_with' + id).val('');
      $('#other_condition_with-mb-' + id).val('');
      $('#other_thing_id' + id).val('');
      $('#other_thing_id-mb-' + id).val('');
      $('#other_sensor_id' + id).val('');
      $('#other_sensor_id-mb-' + id).val('');
      $('#other_condition' + id).val('');
      $('#other_condition-mb-' + id).val('');
      $('#other_target_emo' + id).val('');
      $('#other_target_emo-mb-' + id).val('');
      $('#txt_val_str' + id).val('');
      $('#txt_val_str-mb-' + id).val('');
      $('#txt_val_oth_to' + id).val('');
      $('#txt_val_oth_to-mb-' + id).val('');
      $('#other_condition_and_with' + id).prop("checked", false);
      $('#other_condition_or_with' + id).prop("checked", false);
      $('#other_condition_mb_and_with' + id).prop("checked", false);
      $('#other_condition_mb_or_with' + id).prop("checked", false);
      // console.log("......formEmoticon.value......", this.formEmoticon.value);
      // console.log("......formEmoticon.length......", this.formEmoticon.value.data.length);
      for (let i = 0; i < this.formEmoticon.value.data.length; i++) {
        if (this.formEmoticon.value.data[i].emoId == id) {
          this.formEmoticon.value.data[i].other_thing_id = "";
          this.formEmoticon.value.data[i].other_sensor_id = "";
          this.formEmoticon.value.data[i].other_condition = "";
          this.formEmoticon.value.data[i].other_target_emo = "";
          this.formEmoticon.value.data[i].other_target_emo2 = "";
          if (id == '1') {
            this.formEmoticon.value.data[i].other_condition_with1 = "";
            this.sensorAllOther[id] = [];
          }
          if (id == '2') {
            this.formEmoticon.value.data[i].other_condition_with2 = "";
            this.sensorAllOther[id] = [];
          }
          if (id == '3') {
            this.formEmoticon.value.data[i].other_condition_with3 = "";
            this.sensorAllOther[id] = [];
          }
        }
      }
    }
  }

  chkButtonEditEmo(arr) {
    let bol = false;
    // console.log("!!!!!!!!!!!!!........arr........!!!!!!!!!!!!!!!", arr);
    if (arr) {
      for (let index = 0; index < arr.length; index++) {
        const element = arr[index];
        if (element.condition != null) {
          bol = true;
        }
      }
    }

    if (bol) {
      $('#editEmoPlant').prop("disabled", false);
    } else {
      $('#editEmoPlant').prop("disabled", true);
    }
  }

  cancelEmo() {
    // this.spinner.show();
    // console.log("cancelEmo :")
    setTimeout(async () => {
      this.alertErrorEmo = false;
      this.getEmo();
      this.formEditEmoticon = this.farm.group({
        data: this.farm.array([]),
      });
      this.edt = false;

      // window.location.reload();
      this.spinner.hide();
    }, 100);
  }

  cancelEditEmo() {
    console.log("cancelEditEmo :")
    // this.spinner.show();
    setTimeout(async () => {
      this.alertErrorEmo = false;
      this.formEditEmoticon = this.farm.group({
        data: this.farm.array([]),
      });
      this.edt = false;
      this.getEmo();
      // window.location.reload();
      this.spinner.hide();
    }, 100);
  }

  selectOperation(event, id, type) {
    // console.log("ASDASDSAd event ", event, id, type)


    // alert(event)
    if (type == "add") {
      $('#txt_val_main' + id).val('');
      $('#txt_val' + id).val('');
      $('#txt_val_to' + id).val('');
      if (event == "5") {

        $('#tgUnBtw-pc-' + id).addClass('dis-none');
        $('#tgUnBtw-mb-' + id).addClass('dis-none');
        $('#tgBtw-pc-' + id).removeClass('dis-none');
        $('#tgBtw-mb-' + id).removeClass('dis-none');

      } else {
        $('#tgUnBtw-pc-' + id).removeClass('dis-none');
        $('#tgUnBtw-mb-' + id).removeClass('dis-none');
        $('#tgBtw-pc-' + id).addClass('dis-none');
        $('#tgBtw-mb-' + id).addClass('dis-none');
      }
    } else {
      $('#edt_txt_val_main' + id).val('');
      $('#edt_txt_val' + id).val('');
      $('#edt_txt_val_to' + id).val('');
      if (event == "5") {

        $('#edt_tgUnBtw-pc-' + id).addClass('dis-none');
        $('#edt_tgUnBtw-mb-' + id).addClass('dis-none');
        $('#edt_tgBtw-pc-' + id).removeClass('dis-none');
        $('#edt_tgBtw-mb-' + id).removeClass('dis-none');

      } else {

        $('#edt_tgUnBtw-pc-' + id).removeClass('dis-none');
        $('#edt_tgUnBtw-mb-' + id).removeClass('dis-none');
        $('#edt_tgBtw-pc-' + id).addClass('dis-none');
        $('#edt_tgBtw-mb-' + id).addClass('dis-none');
      }
    }



  }

  selectOtherOperation(event, id, type) {
    console.clear();
    // console.log("event===>", event);
    // console.log("id===>", id);
    if (type == 'create') {
      $('#other_target_emo' + id).val('');
      $('#txt_val_str' + id).val('');
      $('#txt_val_oth_to' + id).val('');
      if (event == "5") {
        // console.log("ถึง")
        $('#tgOtherUnBtw-pc-' + id).addClass('dis-none');
        $('#tgOtherUnBtw-mb-' + id).addClass('dis-none');
        $('#tgOtherBtw-pc-' + id).removeClass('dis-none');
        $('#tgOtherBtw-mb-' + id).removeClass('dis-none');
      } else {
        $('#tgOtherUnBtw-pc-' + id).removeClass('dis-none');
        $('#tgOtherUnBtw-mb-' + id).removeClass('dis-none');
        $('#tgOtherBtw-pc-' + id).addClass('dis-none');
        $('#tgOtherBtw-mb-' + id).addClass('dis-none');
      }
    } else {
      $('#edt_other_target_emo' + id).val('');
      $('#edt_txt_val_str' + id).val('');
      $('#edt_txt_val_oth_to' + id).val('');
      if (event == "5") {
        // console.log("ถึง")
        $('#edt_tgOtherUnBtw-pc-' + id).addClass('dis-none');
        $('#edt_tgOtherUnBtw-mb-' + id).addClass('dis-none');
        $('#edt_tgOtherBtw-pc-' + id).removeClass('dis-none');
        $('#edt_tgOtherBtw-mb-' + id).removeClass('dis-none');
      } else {
        $('#edt_tgOtherUnBtw-pc-' + id).removeClass('dis-none');
        $('#edt_tgOtherUnBtw-mb-' + id).removeClass('dis-none');
        $('#edt_tgOtherBtw-pc-' + id).addClass('dis-none');
        $('#edt_tgOtherBtw-mb-' + id).addClass('dis-none');
      }
    }


  }

  convertOperation(data) {

    let operationSet = [];

    operationSet[">"] = "มากกว่า";
    operationSet["<"] = "น้อยกว่า";
    operationSet["="] = "เท่ากับ";
    operationSet["<>"] = "ไม่เท่ากับ";
    operationSet["BETWEEN"] = "ระหว่าง";

    return operationSet[data];
  }
  showCondition(condition) {
    // console.log("operation : ", condition)
    switch (condition) {
      case '1':
        return 'มากกว่า'
      case '2':
        return 'น้อยกว่า'
      case '3':
        return 'เท่ากับ'
      case '4':
        return 'ไม่เท่ากับ'
      case '5':
        return 'ระหว่าง'
      default: '-'
    }
  }
  findThingById(thingid) {
    // console.log("this.thingsByid", this.thingsByid);
    if (thingid) {
      if (this.thingsByid.length > 0) {
        var foundThing = this.thingsByid.find(function (element) {
          return element.thing_id == thingid;
        });

        // console.log("foundThing.thing_name",foundThing);
        if(foundThing){
          return foundThing.thing_name
        }else{
          return ''
        }
      }
    }
    else return ''
  }

  findSensorById(thingid, sensorid) {
    if (thingid && sensorid) {
      this.thingsByid.forEach(elementT => {
        if (elementT.thing_id == thingid) {
          elementT.sensor.forEach(element => {
            if (element.sensor_id == sensorid) {
              this.ssname = element.sensor_name;
            }
          });
        }
      });
      return this.ssname
    }
    else return ''

  }
  editEmoSection(emoId, value2) {
    // console.log("emoId ", emoId)
    // console.log("value2 ", value2)
    $(`#show-emo-${emoId}`).addClass('hide-select');
    $(`#edit-emo-${emoId}`).removeClass('hide-select');
    $(`#show-emo-mb-${emoId}`).addClass('hide-select');
    $(`#edit-emo-mb-${emoId}`).removeClass('hide-select');
    if (value2) {
      $(`#pnCondition-edit-pc-${emoId}`).removeClass('dis-none');
      $(`#pnCondition-edit-mb-${emoId}`).removeClass('dis-none');
    }
  }
  editEmo(arr) {
    // console.log("//////////////////////arr/////////////", arr);

    $('#editEmoPlant').prop("disabled", true);
    let operationSet = [];
    operationSet[">"] = "1";
    operationSet["<"] = "2";
    operationSet["="] = "3";
    operationSet["<>"] = "4";
    operationSet["BETWEEN"] = "5";


    this.formEditEmoticon = this.farm.group({
      data: this.farm.array([]),
    });
    // console.clear()
    arr.forEach((element, index) => {
      // console.log("element", element);
      this.spinner.show();
      setTimeout(async () => {
        // console.log("element.condition[0].thing_id..>>>>>", element.condition[0].thing_id);
        await this.farmService.getSensorByThingsID(element.condition[0].thing_id,this.plotId).subscribe(async success => {
          // console.log("editEmo success.data : ", success.data)
          this.sensorAll[element.data.emo_status] = success.data;
          this.spinner.hide();

        });
        // console.log("element.data. >", element.data)
        if (operationSet[element.condition[0].operation] == "5") {
          $('#edt_tgUnBtw-pc-' + element.data.emo_status).addClass('dis-none');
          $('#edt_tgUnBtw-mb-' + element.data.emo_status).addClass('dis-none');
          $('#edt_tgBtw-pc-' + element.data.emo_status).removeClass('dis-none');
          $('#edt_tgBtw-mb-' + element.data.emo_status).removeClass('dis-none');
        } else {
          $('#edt_tgUnBtw-pc-' + element.data.emo_status).removeClass('dis-none');
          $('#edt_tgUnBtw-mb-' + element.data.emo_status).removeClass('dis-none');
          $('#edt_tgBtw-pc-' + element.data.emo_status).addClass('dis-none');
          $('#edt_tgBtw-mb-' + element.data.emo_status).addClass('dis-none');
        }

        // console.log("!!!!!!!!!!!!!! element.condition >>", element.condition)
        // console.log("!!! operationSet[element.condition[0].operation];...>>>", operationSet[element.condition[0].operation])

        if (element.condition.length == 2) {
          if (element.data.emo_status == '1') this.addCondition1 = true
          if (element.data.emo_status == '2') this.addCondition2 = true
          if (element.data.emo_status == '3') this.addCondition3 = true
          // console.log("....edit......", this.addCondition1, this.addCondition2, this.addCondition3);

          $('#pnCondition' + element.data.emo_status).removeClass('dis-none');
          $('#pnCondition-mb-' + element.data.emo_status).removeClass('dis-none');
          $('#edt_btnAddCondition' + element.data.emo_status).addClass('disabled');

          if (operationSet[element.condition[1].operation] == "5") {
            $('#edt_tgOtherUnBtw-pc-' + element.data.emo_status).addClass('dis-none');
            $('#edt_tgOtherUnBtw-mb-' + element.data.emo_status).addClass('dis-none');
            $('#edt_tgOtherBtw-pc-' + element.data.emo_status).removeClass('dis-none');
            $('#edt_tgOtherBtw-mb-' + element.data.emo_status).removeClass('dis-none');
          } else {
            $('#edt_tgOtherUnBtw-pc-' + element.data.emo_status).removeClass('dis-none');
            $('#edt_tgOtherUnBtw-mb-' + element.data.emo_status).removeClass('dis-none');
            $('#edt_tgOtherBtw-pc-' + element.data.emo_status).addClass('dis-none');
            $('#edt_tgOtherBtw-mb-' + element.data.emo_status).addClass('dis-none');
          }

          await this.farmService.getSensorByThingsID(element.condition[1].thing_id,this.plotId).subscribe(async success => {
            this.sensorAllOther[element.data.emo_status] = success.data;
            // console.log("res.data.data;",res)
          });
        }
        // console.log("BEFORE END")
      }, 300);



      const checkEmo = <FormArray>this.formEditEmoticon.get('data') as FormArray;

      let other_condition_with = 'other_condition_with' + element.data.emo_status
      checkEmo.push(this.farm.group({
        emoId: element.data.emo_status,
        thing_id: element.condition[0].thing_id,
        sensor_id: element.condition[0].sensor_id,
        condition: operationSet[element.condition[0].operation],
        target_emo: element.condition[0].Value1,
        target_emo2: operationSet[element.condition[0].operation] == "5" ? element.condition[0].Value2 : "",
        [other_condition_with]: element.data.operation,
        other_thing_id: element.condition[1] == undefined ? "" : element.condition[1].thing_id,
        other_sensor_id: element.condition[1] == undefined ? "" : element.condition[1].sensor_id,
        other_condition: element.condition[1] == undefined ? "" : operationSet[element.condition[1].operation],
        other_target_emo: element.condition[1] == undefined ? "" : element.condition[1].Value1,
        other_target_emo2: element.condition[1] == undefined || operationSet[element.condition[1].operation] != "5" ? "" : element.condition[1].Value2,
      }))
      // }

      // console.log("checkEmo..........>>>>>>", checkEmo);


    });

    // this.dtEmo = [];
    this.edt = true;
    // console.log("this.edt : ", this.edt)

  }
  // issue#106
  chkSubmitConfigEditEmo() {
    this.chkConfigEditEmo = true;
    // console.log("this.formEditEmoticon  :", this.formEditEmoticon)
    let things1 = this.formEditEmoticon.value.data[0].thing_id
    let things2 = this.formEditEmoticon.value.data[1].thing_id
    let things3 = this.formEditEmoticon.value.data[2].thing_id
    let sensor1 = this.formEditEmoticon.value.data[0].sensor_id
    let sensor2 = this.formEditEmoticon.value.data[1].sensor_id
    let sensor3 = this.formEditEmoticon.value.data[2].sensor_id
    let cond1 = this.formEditEmoticon.value.data[0].condition
    let cond2 = this.formEditEmoticon.value.data[1].condition
    let cond3 = this.formEditEmoticon.value.data[2].condition
    let value1 = this.formEditEmoticon.value.data[0].target_emo
    let value2 = this.formEditEmoticon.value.data[1].target_emo
    let value3 = this.formEditEmoticon.value.data[2].target_emo
    let subValue1 = this.formEditEmoticon.value.data[0].target_emo
    let subValue2 = this.formEditEmoticon.value.data[1].target_emo
    let subValue3 = this.formEditEmoticon.value.data[2].target_emo
    let subValueTo1 = this.formEditEmoticon.value.data[0].target_emo2
    let subValueTo2 = this.formEditEmoticon.value.data[1].target_emo2
    let subValueTo3 = this.formEditEmoticon.value.data[2].target_emo2

    let AndOr1 = this.formEditEmoticon.value.data[0].other_condition_with1
    let AndOr2 = this.formEditEmoticon.value.data[1].other_condition_with2
    let AndOr3 = this.formEditEmoticon.value.data[2].other_condition_with3

    let things_other1 = this.formEditEmoticon.value.data[0].other_thing_id
    let things_other2 = this.formEditEmoticon.value.data[1].other_thing_id
    let things_other3 = this.formEditEmoticon.value.data[2].other_thing_id
    let sensor_other1 = this.formEditEmoticon.value.data[0].other_sensor_id
    let sensor_other2 = this.formEditEmoticon.value.data[1].other_sensor_id
    let sensor_other3 = this.formEditEmoticon.value.data[2].other_sensor_id
    let cond_other1 = this.formEditEmoticon.value.data[0].other_condition
    let cond_other2 = this.formEditEmoticon.value.data[1].other_condition
    let cond_other3 = this.formEditEmoticon.value.data[2].other_condition
    let value_other1 = this.formEditEmoticon.value.data[0].other_target_emo
    let value_other2 = this.formEditEmoticon.value.data[1].other_target_emo
    let value_other3 = this.formEditEmoticon.value.data[2].other_target_emo
    let subValue_other1 = this.formEditEmoticon.value.data[0].other_target_emo
    let subValue_other2 = this.formEditEmoticon.value.data[1].other_target_emo
    let subValue_other3 = this.formEditEmoticon.value.data[2].other_target_emo
    let subValueTo_other1 = this.formEditEmoticon.value.data[0].other_target_emo2
    let subValueTo_other2 = this.formEditEmoticon.value.data[1].other_target_emo2
    let subValueTo_other3 = this.formEditEmoticon.value.data[2].other_target_emo2
    // console.log("configEditEmo....things1..>>", things1);
    // console.log("configEditEmo....things2..>>", things2);
    // console.log("configEditEmo....things3..>>", things3);
    // console.log("configEditEmo....sensor1..>>", sensor1);
    // console.log("configEditEmo....sensor2..>>", sensor2);
    // console.log("configEditEmo....sensor3..>>", sensor3);
    // console.log("configEditEmo....cond1..>>", cond1);
    // console.log("configEditEmo....cond2..>>", cond2);
    // console.log("configEditEmo....cond3..>>", cond3);
    // console.log("configEditEmo....value1..>>", value1);
    // console.log("configEditEmo....value2..>>", value2);
    // console.log("configEditEmo....value3..>>", value3);
    // console.log("configEditEmo....subValue1..>>", subValue1);
    // console.log("configEditEmo....subValue2..>>", subValue2);
    // console.log("configEditEmo....subValue3..>>", subValue3);
    // console.log("configEditEmo....subValueTo1..>>", subValueTo1);
    // console.log("configEditEmo....subValueTo2..>>", subValueTo2);
    // console.log("configEditEmo....subValueTo3..>>", subValueTo3);
    // console.log("configEditEmo....AndOr1..>>", AndOr1);
    // console.log("configEditEmo....AndOr2..>>", AndOr2);
    // console.log("configEditEmo....AndOr3..>>", AndOr3);

    // console.log("configEditEmo....things_other1..>>", things_other1);
    // console.log("configEditEmo....things_other2..>>", things_other2);
    // console.log("configEditEmo....things_other3..>>", things_other3);
    // console.log("configEditEmo....sensor_other1..>>", sensor_other1);
    // console.log("configEditEmo....sensor_other2..>>", sensor_other2);
    // console.log("configEditEmo....sensor_other3..>>", sensor_other3);
    // console.log("configEditEmo....cond_other1..>>", cond_other1);
    // console.log("configEditEmo....cond_other2..>>", cond_other2);
    // console.log("configEditEmo....cond_other3..>>", cond_other3);
    // console.log("configEditEmo....value_other1..>>", value_other1);
    // console.log("configEditEmo....value_other2..>>", value_other2);
    // console.log("configEditEmo....value_other3..>>", value_other3);
    // console.log("configEditEmo....subValue_other1..>>", subValue_other1);
    // console.log("configEditEmo....subValue_other2..>>", subValue_other2);
    // console.log("configEditEmo....subValue_other3..>>", subValue_other3);
    // console.log("configEditEmo....subValueTo_other1..>>", subValueTo_other1);
    // console.log("configEditEmo....subValueTo_other2..>>", subValueTo_other2);
    // console.log("configEditEmo....subValueTo_other3..>>", subValueTo_other3);

    if (things1 == 'กรุณาเลือกThings' || things1 == null || things2 == 'กรุณาเลือกThings' || things2 == null || things3 == 'กรุณาเลือกThings' || things3 == null || sensor1 == null || sensor2 == null || sensor3 == null || cond1 == null || cond2 == null || cond3 == null) {
      this.chkConfigEditEmo = false;
    }
    if (cond1) {
      if (cond1 == '5') {
        if (subValue1 == '' || subValueTo1 == '') {
          this.chkConfigEditEmo = false;
        }
      } else {
        if (value1 == '') {
          this.chkConfigEditEmo = false;
        }
      }
    } else {
      this.chkConfigEditEmo = false;
    }
    if (cond2) {
      if (cond2 == '5') {
        if (subValue2 == '' || subValueTo2 == '') {
          this.chkConfigEditEmo = false;
        }
      } else {
        if (value2 == '') {
          this.chkConfigEditEmo = false;
        }
      }
    } else {
      this.chkConfigEditEmo = false;
    }
    if (cond3) {
      if (cond3 == '5') {
        if (subValue3 == '' || subValueTo3 == '') {
          this.chkConfigEditEmo = false;
        }
      } else {
        if (value3 == '') {
          this.chkConfigEditEmo = false;
        }
      }
    } else {
      this.chkConfigEditEmo = false;
    }
    if (this.addCondition1) {
      if (AndOr1) {
        if (things_other1 == 'กรุณาเลือกThings' || things_other1 == null || sensor_other1 == null || cond_other1 == null) {
          this.chkConfigEditEmo = false;
        }
        if (cond_other1) {
          if (cond_other1 == '5') {
            if (subValue_other1 == '' || subValueTo_other1 == '') {
              this.chkConfigEditEmo = false;
            }
          } else {
            if (value_other1 == '') {
              this.chkConfigEditEmo = false;
            }
          }
        } else {
          this.chkConfigEditEmo = false;
        }

      } else {
        this.chkConfigEditEmo = false;
      }
    }
    if (this.addCondition2) {
      if (AndOr2) {
        if (things_other2 == 'กรุณาเลือกThings' || things_other2 == null || sensor_other2 == null || cond_other2 == null) {
          this.chkConfigEditEmo = false;
        }
        if (cond_other2) {
          if (cond_other2 == '5') {
            if (subValue_other2 == '' || subValueTo_other2 == '') {
              this.chkConfigEditEmo = false;
            }
          } else {
            if (value_other2 == '') {
              this.chkConfigEditEmo = false;
            }
          }
        } else {
          this.chkConfigEditEmo = false;
        }
      } else {
        this.chkConfigEditEmo = false;
      }
    }
    if (this.addCondition3) {
      if (AndOr3) {
        if (things_other3 == 'กรุณาเลือกThings' || things_other3 == null || sensor_other3 == null || cond_other3 == null) {
          this.chkConfigEditEmo = false;
        }
        if (cond_other3) {
          if (cond_other3 == '5') {
            if (subValue_other3 == '' || subValueTo_other3 == '') {
              this.chkConfigEditEmo = false;
            }
          } else {
            if (value_other3 == '') {
              this.chkConfigEditEmo = false;
            }
          }
        } else {
          this.chkConfigEditEmo = false;
        }
      } else {
        this.chkConfigEditEmo = false;
      }
    }
  }

  configEditEmo() {
    this.chkSubmitConfigEditEmo();
    // console.log("this.chkConfigEditEmo..>>", this.chkConfigEditEmo);
    // console.log("this.alertErrorEmo..>>", this.alertErrorEdtEmo);

    if (this.chkConfigEditEmo == true) {
      this.alertErrorEdtEmo = false;
      let operationSet = [];
      this.dataMain = [];

      operationSet["1"] = ">";
      operationSet["2"] = "<";
      operationSet["3"] = "=";
      operationSet["4"] = "<>";
      operationSet["5"] = "BETWEEN";
      const emodata = <FormArray>this.formEditEmoticon.get('data') as FormArray;
      emodata.value.forEach(element => {

        let mrgCondition = [];

        if (element.thing_id != "") {
          let Condition = {
            thing_id: element.thing_id,
            sensor_id: element.sensor_id,
            operation: operationSet[element.condition],
            Value1: element.target_emo,
            Value2: element.target_emo2 == "" ? null : element.target_emo2,
          };

          if (element.other_thing_id != "") {
            let conditionTwo = {
              thing_id: element.other_thing_id,
              sensor_id: element.other_sensor_id,
              operation: operationSet[element.other_condition],
              Value1: element.other_target_emo,
              Value2: element.other_target_emo2 == "" ? null : element.other_target_emo2,
            };

            mrgCondition.push(Condition, conditionTwo)
          } else {
            mrgCondition.push(Condition)
          }

          let jsonData = JSON.stringify(mrgCondition);
          let other_condition_with = 'other_condition_with' + element.emoId

          // console.log("chk other jsonData :", jsonData);
          // console.log("chk other other condi :", other_condition_with);
          // console.log("chk other element:", element[other_condition_with]);

          this.dataMain.push({
            emo_status: element.emoId,
            comp_code: sessionStorage.getItem("comp_code"),
            condition: jsonData,
            operation: element[other_condition_with],
            user: sessionStorage.getItem("userid")
          })
          // console.log("::dataMain::", this.dataMain);
        }

      });

      if (this.dataMain.length > 0) {
        this.mergeArr = {
          farm_id: this.farmId,
          plot_id: this.plotId,
          data: this.dataMain
        }

      }

      // console.log("this.mergeArr ====>", this.mergeArr);

      this.spinner.show();
      setTimeout(async () => {

        await this.farmService.getUpdateEmobyPlot(this.mergeArr).subscribe(async success => {
          if (success.code == 200) {
            $('#setEmoticon').modal('hide');
            Swal.fire({
              icon: 'success',
              title: 'ดำเนินการเสร็จสิ้น',
              showConfirmButton: false,
              timer: 1500
            })

            this.spinner.show();
            setTimeout(async () => {
              window.location.reload();
              this.spinner.hide();
            }, 1800);
          } else {
            $('#setEmoticon').modal('hide');
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาดในการสร้างฟาร์ม กรุณาลองใหม่อีกครั้ง',
              showConfirmButton: false,
              timer: 1500
            })
          }
        });


        this.spinner.hide();
      }, 100);
    } else {
      // console.log("!@#!@#!@#!@#")
      this.alertErrorEdtEmo = true;
    }
  }

  // NEW CODE ADD HERE!
  emoticon_expand1 = false;
  emoticon_expand2 = false;
  emoticon_expand3 = false;

  emoticon_expand_1() {
    if (this.emoticon_expand1 == true) {
      this.emoticon_expand1 = false
      $('#select-your-value').removeClass('hide-select');
    } else if (this.emoticon_expand1 == false) {
      this.emoticon_expand1 = true
      $('#select-your-value').addClass('hide-select');
    }
  }
  emoticon_expand_2() {
    if (this.emoticon_expand2 == true) {
      this.emoticon_expand2 = false
      $('#select-your-value').removeClass('hide-select');
    } else if (this.emoticon_expand2 == false) {
      this.emoticon_expand2 = true
      $('#select-your-value').addClass('hide-select');
    }
  }
  emoticon_expand_3() {
    if (this.emoticon_expand3 == true) {
      this.emoticon_expand3 = false
      $('#select-your-value').removeClass('hide-select');
    } else if (this.emoticon_expand3 == false) {
      this.emoticon_expand3 = true
      $('#select-your-value').addClass('hide-select');
    }
  }

  editemokub() {
    this.dtEmo = []
  }

}
